<div class="match-cards-scroll">
  <div class="match-cards" [class.is-match-play]="golfTour.tournament_type === 'match_play'">
    @for (m of vm; track trackByMatch(i, m); let i = $index) {
      <!-- <div class="format-label">{{ m.label }}</div> -->
      <div
        class="match-card clickable"
        [ngClass]="{ 'foursomes': m.label === 'Foursomes', 'expanded': expandedIds.has(m.id) }"
        (click)="toggleExpand(m)"
        >
        <!-- row 1 -->
        <div class="row">
          <div class="side left">
            @if (m.left[0]; as p) {
              <span class="avatar-ring team1">
                <app-image
                  [player]="p.player"
                  [display_flag]="true"
                  [app_country_flag_width]="'20px'"
                  [width]="'36px'"
                  [height]="'36px'"
                  margin="0"
                  [override_country]="flagCode(p.player)"
                  [lazy]="true">
                </app-image>
              </span>
              <span class="name">{{ shortName(p.player) }}</span>
            }
          </div>
          <div class="center" [ngClass]="{ 'center-floating': m.label === 'Foursomes' }">
            @if (shouldShowTeeTime(m)) {
              <div class="score tee-time">
                {{ teeTimeLabel(m) }}
              </div>
            } @else {
              @if (m.scoreText) {
                <div
                  class="score"
                  [ngClass]="{ 'colored': !!m.scoreBg, 'neutral': !m.scoreBg }"
                  [style.--pill-bg]="m.scoreBg || null"
                  [attr.data-team]="m.scoreTeamKey || null"
                  >
                  {{ m.scoreText }}
                </div>
              }
              @if (m.statusLabel) {
                <div class="status">
                  {{ m.statusLabel }}
                </div>
              }
              @if (hasPlayoff(m)) {
                <div class="status">
                  {{ playoffText }}
                </div>
              }
            }
          </div>
          <div class="side right">
            @if (m.right[0]; as p) {
              <span class="name right-name">{{ shortName(p.player) }}</span>
              <span class="avatar-ring team2">
                <app-image
                  [player]="p.player"
                  [display_flag]="true"
                  [app_country_flag_width]="'20px'"
                  [width]="'36px'"
                  [height]="'36px'"
                  margin="0"
                  [override_country]="flagCode(p.player)"
                  [lazy]="true">
                </app-image>
              </span>
            }
          </div>
        </div>
        <!-- row 2 (only for foursomes) -->
        @if (m.left.length > 1 || m.right.length > 1) {
          <div class="row">
            <div class="side left">
              @if (m.left[1]; as p) {
                <span class="avatar-ring team1">
                  <app-image
                    [player]="p.player"
                    [display_flag]="true"
                    [app_country_flag_width]="'20px'"
                    [width]="'36px'"
                    [height]="'36px'"
                    margin="0"
                    [override_country]="flagCode(p.player)"
                    [lazy]="true"
                    >
                  </app-image>
                </span>
                <span class="name">{{ shortName(p.player) }}</span>
              }
            </div>
            <div class="status status-empty"></div>
            <div class="side right">
              @if (m.right[1]; as p) {
                <span class="name right-name">{{ shortName(p.player) }}</span>
                <span class="avatar-ring team2">
                  <app-image
                    [player]="p.player"
                    [display_flag]="true"
                    [app_country_flag_width]="'20px'"
                    [width]="'36px'"
                    [height]="'36px'"
                    margin="0"
                    [override_country]="flagCode(p.player)"
                    [lazy]="true"
                    >
                  </app-image>
                </span>
              }
            </div>
          </div>
        }
        @if (hasScorecard(m) && !expandedIds.has(m.id)) {
          <div
            class="ellipsis-wrapper"
            (click)="toggleExpandFromIcon($event, m)"
            >
            <img class="ellipsis" src="assets/golf/ellipsis.circle.svg" alt="more" />
          </div>
        }
      </div>
      @if (expandedIds.has(m.id)) {
        <app-matchplay-scorecard
          [isFinished]="m.status === 'finished'"
          [gameType]="m?.gameType ?? null"
          class="mp-embed"
          [left]="m.left"
          [right]="m.right"
          [aggregate]="m?.aggregate ?? []"
          [extraAggregate]="m?.extraAggregate ?? []">
        </app-matchplay-scorecard>
      }
      @if (shouldShowBanner(i)) {
        <app-sponsor-banner
          [margin]="'0.3rem 0 0 0'"
          [location]="'Golf Scorecard Matches'"
          [sponsor_key]="'golf-scorecard-matches'"
          [aspect_ratio]="'9:1'">
        </app-sponsor-banner>
      }
    }
  </div>
</div>
